// Brand lockup: "FIRST STEP" large (black, or white on dark), "FIRE PREP" smaller in red, side by side.
export function Wordmark({ onDark = false, size = "md" }) {
  const big = size === "lg" ? "text-3xl" : size === "sm" ? "text-lg" : "text-2xl";
  const small = size === "lg" ? "text-base" : size === "sm" ? "text-[11px]" : "text-sm";
  return (
    <span className="font-heading font-extrabold uppercase tracking-tight inline-flex items-baseline gap-1.5 leading-none whitespace-nowrap" data-testid="wordmark" aria-label="First Step Fire Prep">
      <span className={`${big} ${onDark ? "text-white" : "text-slate-900 dark:text-white"}`}>First Step</span>
      <span className={`${small} text-primary tracking-wide`}>Fire Prep</span>
    </span>
  );
}
